var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 20.5862L24.414 19.0002L26 17.4142L27.586 19.0002L26 20.5862ZM19.586 27.0002H18V25.4142L23 20.4142L24.586 22.0002L19.586 27.0002ZM29.707 18.2933L26.707 15.2932C26.316 14.9022 25.684 14.9022 25.293 15.2932L16 24.5862V29.0002H20.414L29.707 19.7072C30.098 19.3162 30.098 18.6843 29.707 18.2933Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H27V5H5V9ZM5 3H27C28.1 3 29 3.896 29 5V13H27V11H17V20H15V11H5V18H15V20H5V27H14V29H5C3.89 29 3 28.104 3 27V5C3 3.896 3.89 3 5 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualGrid);
export default __webpack_public_path__ + "static/media/manual-grid.252900b73dbb1b23a27134b6bd1365e4.svg";
export { ForwardRef as ReactComponent };